export default {
	data() {
		return {
			//搜索学生的条件
			searchStudent: {
				name: '',
				score: '',
				is_pass: '',
				category_name: '',
				start_exam_time: '',
				end_exam_time: '',
			},
			yesOrNo:['是','否'],
			// 课程类型
			courseStyle: ['专业课', '选修课'],
			// 学习状态
			studyType: ['未开始', '学习中', '已完成'],
			// 学生数据
			studnetData: [],
			//绑定在输入框的学员信息
			stuInfo: {},
			//已经勾选了多少个学生
			paruseStudent: [],
			//查看学员信息弹出框
			dialogTabelVisible: false,
			// 修改学员成绩弹出框
			alertDialoglVisible:false,
			// loading状态
			fullscreenLoading: false,
			// 总学员数
			studentTotal: 0,
			// 分页器每页的数量
			pageLen: 15,
			// 当前页数
			currentPage:1,
			offset:0,
			peopleList:['测试1','测试','测试4','测试3','测试2','测试2',]
			

		}
	},
	methods: {
		// 搜索
		confirmSearch() {
			this.offset = 0;
			this.currentPage = 1
			this.getAllStudent()
		},
		//点击学员多选框
		handleStudentChange(val) {
			this.stuInfo = val[0]
			let arr = [];
			for (let item of val) {
				arr.push(item.id);
			}
			this.paruseStudent = arr;
		},
		// 查看单个学员
		lookStudent() {

			if (this.paruseStudent.length == 0) {
				this.$message({
					type: 'error',
					message: '请选择用户'
				})
				return false
			} else if (this.paruseStudent.length > 1) {
				this.$message({
					type: 'error',
					message: '请选择单个用户'
				})
				return false
			} else {
				this.dialogTabelVisible = true;
			}
		},
		//改变分页器每页数量
		handleSizeChange(val) {
			this.pageLen = val;
			this.getAllStudent();
		},
		//改变分页器当前页数
		getStudentPage(currentPage) {
			this.currentPage = currentPage;
			this.offset = (Number.parseInt(currentPage) - 1) * this.pageLen;
			this.confirmSearch()

		},
		//修改学员信息
		ModifyStudent(){
			
			if (this.paruseStudent.length == 0) {
				this.$message({
					type: 'error',
					message: '请选择用户'
				})
				return false
			} else if (this.paruseStudent.length > 1) {
				this.$message({
					type: 'error',
					message: '请选择单个用户'
				})
				return false
			} else {
				this.alertDialoglVisible = true;
			}
		},
		//获取所有学生的信息
		getAllStudent() {
			this.fullscreenLoading = true
			this.searchType = true;
			this.$post('userAdmin/examResult', {
				token: this.$store.state.authority_management,
				offset: this.offset,
				length: this.pageLen,
				score: this.searchStudent.score,
				name: this.searchStudent.name,
				is_pass: this.searchStudent.is_pass,
				category_name: this.searchStudent.category_name,
				start_exam_time: this.searchStudent.start_exam_time,
				end_exam_time: this.searchStudent.end_exam_time,
			}).then(res => {
				console.log(res)
				this.studentTotal = res.data.result.total;
				this.studnetData = res.data.result.result;
				this.fullscreenLoading = false
			})
		},
	},
	created() {
		this.getAllStudent()
	}

}
